export enum CTSDistributionColumns {
	VersionAmcnId = 'VERSION_AMCN_ID',
	AmcnId = 'AMCN_ID',
	SeasonAmcnId = 'SEASON_AMCN_ID',
	SeriesAmcnId = 'SERIES_AMCN_ID',
	MediaAmcnId = 'MEDIA_ID',
	Title = 'TITLE',
	ProductType = 'PRODUCT_TYPE',
	PressTarget = 'PRESS_TARGET',
	Platform = 'PLATFORM',
	StartDate = 'START_DATE',
	ContentId = 'CONTENT_ID',
	VariantContentId = 'VARIANT_ID',
	SeasonContentId = 'SEASON_CONTENT_ID',
	SeriesContentId = 'SERIES_CONTENT_ID',
	PackageContentId = 'PACKAGE_CONTENT_ID',
	PackageMediaContentId = 'PACKAGE_MEDIA_CONTENT_ID',
	PackageAdrefContentId = 'PACKAGE_ADREF_CONTENT_ID',
	PackageMovieId = 'PACKAGE_MOVIE_ID',
	CtsContentId = 'CTS_CONTENT_ID',
	CtsSeriesContentId = 'CTS_SERIES_CONTENT_ID',
	CtsSeasonContentId = 'CTS_SEASON_CONTENT_ID',
	CtsPackageContentId = 'CTS_PACKAGE_CONTENT_ID',
	CtsPackageMovieId = 'CTS_PACKAGE_MOVIEID',
	CtsPartnerPackageAssetId = 'CTS_PARTNER_PACKAGE_A',
	CtsPartnerPackageTitleId = 'CTS_PARTNER_PACKAGE_T',
	CtsPartnerPackageMediaId = 'CTS_PARTNER_PACKAGE_M',
}

export enum CTSDistributionDateFilter {
	dateFrom = 'DATE_FROM',
	dateTo = 'DATE_TO',
}
